import React from 'react';
import { cn } from '@/utils/common-helpers';
import Image from 'next/image';

export function FeaturesSectionHoverEffectsVuejs() {
    const features = [
        {
            title: 'Vue.js Consulting Services',
            description:
                'It is crucial to understand which technology or tools will suit your project. Our team of experts will conceptualize your business idea to provide a free consultation. We will help you to decide on the right technology and developers for your project.',
            icon: '/img/technology/ic-consulting-services.svg',
        },
        {
            title: 'Custom Vue.js Development',
            description:
                'We offer end-to-end custom Vue.js development services based on the client\'s business requirements. We strategize and create unique Vue.js apps using animations and interactive elements seamlessly integrated with multiple apps.',
            icon: '/img/technology/ic-development.svg',
        },
        {
            title: 'Custom SPAs Development',
            description:
                'Our team of skilled developers can build custom Single-Page Applications (SPAs) effortlessly and enable you to provide a prolific solution for growth and success in the global business market.',
            icon: '/img/technology/ic-spas.svg',
        },
        {
            title: 'Vue.js Portal Development',
            description:
                "We are experts in designing and developing custom portals for diverse industries such as eCommerce, resource management, enterprise management, and more. Hire dedicated vue.js developers from Moweb for customized business portal development.",
            icon: '/img/technology/ic-portaldevelopment.svg',
        },
        {
            title: 'Real-time Web & App Development',
            description:
                'Our experienced team is capable of creating real-time web apps and mobile apps that are intuitive and interactive fulfilling your business requirements. Vue.js apps deliver user-oriented interfaces for the business of our esteemed customers globally.',
            icon: '/img/technology/ic-webapp.svg',
        },
        {
            title: 'Vue.js Migration & Upgradation',
            description:
                'Our Vue.js development specialists can migrate you from existing architecture to Vue.js frameworks with ease to meet your business needs. Moweb provides end-to-end technology upgradation for your existing Vue.js applications to enable them to work flawlessly across devices.',
            icon: '/img/technology/ic-migration-upgradation.svg',
        },
    ];
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  relative z-10 max-w-7xl mx-auto">
            {features.map((feature, index) => (
                <Feature key={feature.title} {...feature} index={index} total={features.length} />
            ))}
        </div>
    );
}

const Feature = ({
    title,
    description,
    icon,
    index,
    total,
}: {
    title: string;
    description: string;
    icon: string;
    index: number;
    total: number;
}) => {
    return (
        <div
            className={cn(
                'flex flex-col py-[30px] relative group/feature dark:border-neutral-800',
                index % 3 === 0 && 'lg:border-l dark:border-neutral-800',
                (index + 1) % 3 !== 0 && 'lg:border-r dark:border-neutral-800',
                index >= 3 && 'lg:border-t dark:border-neutral-800 ',
                index === 5 && 'dark:border-neutral-800 ',
                index === 5 && total % 2 === 0 && 'mb-[-1.2px]',
            )}
        >
            {index < 3 && (
                <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-t from-[#F5F6F9] dark:from-neutral-800 to-transparent pointer-events-none" />
            )}
            {index >= 3 && (
                <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-b from-[#F5F6F9] dark:from-neutral-800 to-transparent pointer-events-none" />
            )}
            <div className="mb-[10px] relative z-10 px-10 text-neutral-600 dark:text-neutral-400">
                <Image src={icon} width={36} height={36} alt={title} title={title} className="" />
            </div>
            <div className="text-2xl font-bold mb-[10px] relative z-10 px-[30px]">
                <div className="absolute left-0 inset-y-0 h-6 group-hover/feature:h-8 w-1 rounded-tr-full rounded-br-full bg-neutral-300 dark:bg-neutral-700 group-hover/feature:bg-primary transition-all duration-200 origin-center" />
                <span className="group-hover/feature:translate-x-2 group-hover/feature:text-primary transition duration-200 inline-block text-neutral-800 dark:text-neutral-100">
                    {title}
                </span>
            </div>
            <p className="text-[#4C5773] mb-0 text-base text-neutral-600 dark:text-neutral-300 relative z-10 px-[30px]">
                {description}
            </p>
        </div>
    );
};
